export const publicHolidayColor = 'blue.400';
export const holidayColor = 'red.600';
export const sickColor = '#F4E669';
export const otherColor = 'orange';
export const fontColor = 'white';
export const blackFont = 'black'
export const selectionColor = 'blue.500';
export const defaultBorderColor = '#afafaf';
export const workdayColor = 'white';
export const nonWorkdayColor = 'gray.300';
